/* Footer Builder — accordion + entrance animation behavior. Vanilla JS, no dependencies. */
(function () {
  'use strict';

  var TABLET_BREAKPOINT = 989;
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initAccordions() {
    var items = document.querySelectorAll('[data-ftb-accordion]');
    if (!items.length) return;

    var isMobile = window.innerWidth <= TABLET_BREAKPOINT;

    items.forEach(function (details) {
      var defaultOpen = details.getAttribute('data-default-open') === 'true';
      if (isMobile) {
        if (defaultOpen) {
          details.setAttribute('open', '');
        } else {
          details.removeAttribute('open');
        }
      } else {
        details.setAttribute('open', '');
      }
    });
  }

  function debounce(fn, wait) {
    var timeout;
    return function () {
      clearTimeout(timeout);
      timeout = setTimeout(fn, wait);
    };
  }

  function initAnimations() {
    var targets = document.querySelectorAll('[data-ftb-anim]:not([data-ftb-anim="none"])');
    if (!targets.length) return;

    if (reduceMotion || typeof IntersectionObserver === 'undefined') {
      targets.forEach(function (el) {
        el.classList.add('is-visible');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
    );

    targets.forEach(function (el) {
      observer.observe(el);
    });
  }

  function init() {
    initAccordions();
    initAnimations();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('resize', debounce(initAccordions, 150));

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target.querySelector('.ftb')) {
      initAccordions();
      initAnimations();
    }
  });
})();